<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="pageloader">
    </div>
    <div class="col-12 middle-background main-card"  v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 mt-5 middle-background createsidemenu">
        </div>
        
        <div class="col-md-12 col-lg-6 pb-5 mb-4 middle-background centercard">
          <div class="row no-gutters">
            <br />
          </div>
          <div id="main">
            <div class="col ml-sm-1 pr-md-2 ml-md-2 no-gutters d-block d-lg-none horizontmenu">
            </div>
            <div>
              <div class="row no-gutters">
                <br/>
              </div>
              <div class="accordion" id="faq">
                <div class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                  <div class="col-12">
                    <div class="mt-4 ml-lg-2 ml-md-0 d-flex justify-content-between col-lg-10 ">
                      <span tag="a" v-if="isEditPage" @click="cancelEditPage">
                        <img src="../assets/Back.svg" alt="back"/>
                        <label class="ml-2 mt-4 fontsize-20 pointer proximanova">Edit Recruiter Account</label>
                      </span>
                      <div v-else @click="blockNavigation">
                        <img src="../assets/Back.svg" alt="back"/>
                        <label class="ml-2 mt-4 fontsize-20 pointer proximanova">Create Recruiter Account</label>
                      </div>
                    </div>
                    <div class="card mt-lg-2 mt-md-3 mt-sm-1">
                      <div class="card-header" id="businessidentity">
                        <a
                          href="#businessidentity"
                          class="btn btn-header-link proximanova"
                        >Profile Details</a>
                      </div>
                      <div
                        id="faq1"
                        class="collapse show"
                        aria-labelledby="businessidentity"
                        data-parent="#faq"
                      >
                        <div class="">
                          <div class="row no-gutters profilepicturesection ">
                            <div class="col d-flex ml-4 mt-5">
                            
                              <div v-if="this.profilePicLink=='' || this.profilePicLink == undefined">   
                                <img class="photo" src="../assets/AddPhoto.svg" alt="add"/>
                              </div>
                              <div v-else class="profile-pic">
                                <div class="profile-border ">
                                  <img :src="this.profilePicLink" oncontextmenu="return false" alt="profilepic" class="photo" >
                                </div>
                              </div>
                            </div>
                            <img  style="float:right" src="../assets/ProfileImages.svg" alt="profilepic" class="mt-5 profimg"/>
                          </div>
                        </div>
                        <div class="card-body pb-5">
                          <div class="form">
                            <div class="row no-gutters mb-3 mb-md-0">
                              <div class="col d-md-flex justify-content-start align-items-center">
                                <div class="col-md-6">
                                  <small class="required ml-2 fontsize14 black60 proximanova" v-if="isEditPage">First Name</small>
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      name="First Name"
                                      data-vv-as="First Name"
                                      class="input-create"
                                      v-model="firstName"
                                      autocomplete="off"
                                      v-validate=" 'required' "
                                      data-vv-scope="addBasicinfo"
                                      maxlength="20"
                                      @keypress="allowOnlyNumbersandCharacters"
                                      @keyup="checkfornumbersanddigits"
                                      required
                                    />
                                    <span class="bar"></span>
                                    <label class="label-create required proximanova" v-if="!isEditPage">First Name</label>
                                  </div>
                                  <div class="d-block d-md-none">
                                    <div v-if="errors.has('addBasicinfo.First Name')" class="alert-danger">{{ errors.first('addBasicinfo.First Name') }}</div>
                                    <div v-if="!validfirstname" class="alert-danger">First Name shouldn't contains numbers and symbols</div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <small class="required ml-2 fontsize14 black60 proximanova" v-if="isEditPage">Last Name</small>
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      name="Last Name"
                                      data-vv-as="Last Name"
                                      class="input-create"
                                      v-model="lastName"
                                      autocomplete="off"
                                      v-validate=" 'required' "
                                      data-vv-scope="addBasicinfo"
                                      maxlength="20"
                                      @keypress="allowOnlyNumbersandCharacters"
                                      @keyup="checkfornumbersanddigits"
                                      required
                                    />
                                    <span class="bar"></span>
                                    <label class="label-create required proximanova" v-if="!isEditPage">Last Name</label>
                                  </div>
                                  <div class="d-block d-md-none">
                                    <div v-if="errors.has('addBasicinfo.Last Name')" class="alert-danger">{{ errors.first('addBasicinfo.Last Name') }}</div>
                                    <div v-if="!validlastname" class="alert-danger">Last Name shouldn't contains numbers and symbols</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- display error messages for large devices -->
                            <div class="row no-gutters mb-3 d-none d-md-block">
                              <div class="col d-md-flex justify-content-start align-items-center">
                                <div class="col-md-6">
                                  <div v-if="errors.has('addBasicinfo.First Name')" class="alert-danger">{{ errors.first('addBasicinfo.First Name') }}</div>
                                  <div v-if="!validfirstname" class="alert-danger">First Name shouldn't contains numbers and symbols</div>
                                </div>
                                <div class="col-md-6">
                                  <div v-if="errors.has('addBasicinfo.Last Name')" class="alert-danger">{{ errors.first('addBasicinfo.Last Name') }}</div>
                                  <div v-if="!validlastname" class="alert-danger">Last Name shouldn't contains numbers and symbols</div>  
                                </div>
                              </div>
                            </div>
                            <div class="row no-gutters mb-3 mb-md-0">
                              <div class="col d-md-flex justify-content-start align-items-center">
                                <div class="col-md-6">
                                  <small class="required ml-2 fontsize14 black60 proximanova">Work Email</small>
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      name="Work Email"
                                      data-vv-as="Work Email"
                                      class="input-create p-1"
                                      v-model="workEmail"
                                      autocomplete="off"
                                      v-validate=" 'required' "
                                      data-vv-scope="addBasicinfo"
                                      disabled
                                      required
                                    />
                                    <span class="bar"></span>
                                  </div>
                                  <div class="col d-block d-md-none ml-2">
                                    <div v-if="errors.has('addBasicinfo.Work Email')" class="alert-danger">{{ errors.first('addBasicinfo.Work Email') }}</div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <small class="required ml-2 fontsize14 black60 proximanova" v-if="isEditPage">Company</small>
                                  <div class="input-group mt-3">
                                    <input
                                      type="text"
                                      name="Company"
                                      data-vv-as="Company"
                                      class="input-create p-2"
                                      v-model="companyName"
                                      autocomplete="off"
                                      v-validate=" 'required' "
                                      data-vv-scope="addBasicinfo"
                                      @keyup="checkCompany()"
                                      :disabled="isEditPage"
                                      required
                                    />
                                    <span class="bar"></span>
                                    <label class="label-create required proximanova" v-if="!isEditPage">Company</label>
                                    <div class="dropdown-menu col-10 d-flex" :class="{'dropdownheight':(registeredCompaniesList.length >= 4)}" id="LocationDropdown" v-if="registeredCompaniesList.length > 0 || companieslistloader"> 
                                      <div class="mx-auto p-2" v-if="companieslistloader">
                                        <img src="../assets/loading2.svg" width="30px" height="30px" alt="img">
                                      </div>
                                      <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer" v-else>
                                        <div class="list-group-item pl-3" v-for="(company,i) in registeredCompaniesList" :key="i" 
                                        @click="addCompany(company.companyName,company.companyProfileId)">
                                          <div class="d-flex">
                                            <div class="col-3">
                                              <img v-if="company.companyLogo" :src="company.companyLogo" alt="logo" width="30px" height="30px" class="borderradius20 img-fluid">
                                              <img v-else src="../assets/Company_Icon.svg" alt="logo" width="30px" height="30px" class="borderradius20 img-fluid">
                                            </div>
                                            <div class="d-flex flex-column">
                                              <div class="proximanove-semibold fontsize14 black mb-0">{{company.companyName}}</div>
                                              <div class="proximanove fontsize12 black80 mb-0">{{company.location}}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col d-block d-md-none ml-2">
                                    <div v-if="errors.has('addBasicinfo.Company')" class="alert-danger">{{ errors.first('addBasicinfo.Company') }}</div>
                                    <div v-if="companyName.length>=3 && !companieslistloader && !selectedCompanyProfileId" class="alert-danger">We don't find {{companyName}}, please <span class="blue underline pointer" @click="NavToCompanySignup">Create free company profile</span></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row no-gutters mb-3 d-none d-md-block">
                              <div class="col d-md-flex justify-content-start align-items-center">
                                <div class="col-md-6">
                                  <div class="col d-flex ml-2">
                                    <div v-if="errors.has('addBasicinfo.Work Email')" class="alert-danger">{{ errors.first('addBasicinfo.Work Email') }}</div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="col d-flex ml-2">
                                    <div v-if="errors.has('addBasicinfo.Company')" class="alert-danger">{{ errors.first('addBasicinfo.Company') }}</div>
                                    <div v-if="companyName.length>=3 && !companieslistloader && !selectedCompanyProfileId" class="alert-danger">We don't find {{companyName}}, please <span class="blue underline pointer" @click="NavToCompanySignup">Create free company profile</span></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row no-gutters mb-3 mb-md-0">
                              <div class="col d-md-flex col-12 justify-content-start align-items-center">
                                <div class="col-md-6">
                                  <div class="input-group mt-3">
                                    <input
                                      type="text"
                                      name="Location"
                                      data-vv-as="Location"
                                      class="input-create p-2"
                                      v-model="LocationString"
                                      autocomplete="off"
                                      v-validate=" 'required' "
                                      data-vv-scope="addBasicinfo"
                                      @keyup="checkLocation()"
                                      required
                                    />
                                    <span class="bar"></span>
                                    <label class="label-create required proximanova">Location</label>
                                    <div class="dropdown-menu col-10 d-flex" :class="{'dropdownheight':(locationsList.length >= 6)}" id="LocationDropdown" v-if="locationsList.length > 0 || locationlistloader"> 
                                      <div class="mx-auto p-2" v-if="locationlistloader">
                                        <img src="../assets/loading2.svg" width="30px" height="30px" alt="img">
                                      </div>
                                      <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer" v-else>
                                        <li class="list-group-item pl-3" v-for="(loc,i) in locationsList" :key="i" 
                                        @click="addLocation(loc)">
                                          <div class="proximanove fontsize14 black80 mb-0">{{loc.location}}</div>
                                        </li>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col d-block d-md-none ml-2">
                                    <span class="proximanova black60 fontsize12">Eg: Hyderabad,Telangana,India (City,state,country)</span>
                                    <div v-if="errors.has('addBasicinfo.Location')" class="alert-danger">{{ errors.first('addBasicinfo.Location') }}</div>
                                    <div v-if="LocationString.length>0 && !locationlistloader && !city && !state && !country" class="alert-danger">Please add valid Location</div>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 pl-0 pr-0">
                                  <div class="col d-flex mt-2">
                                    <div class="col-4 countryCodeInput ">
                                      <select
                                        type="text"
                                        name="comapnySize"
                                        data-vv-as="comapnySize"
                                        data-vv-scope="addBasicinfo"
                                        class="input-create countryCodeInputfield proximanova"
                                        onclick="this.setAttribute('value', this.value);"
                                        v-model="countryCode"
                                        required
                                      >
                                        <option
                                          v-for="(cc,index) in countyCodesList"
                                          :value="cc.countryCode"
                                          :key="index"
                                        >{{cc.countryName}}({{cc.countryCode}})</option>
                                      </select>
                                    </div>
                                    <div class="input-group col-8 pr-0">
                                      <input
                                        type="text"
                                        name="Mobile Number"
                                        v-validate="'required|min:10|max:14'"
                                        @input="formatCellPhoneNumber"
                                        @blur="formatCellPhoneNumber"
                                        data-vv-as="contactNumber"
                                        data-vv-scope="addBasicinfo"
                                        class="input-create p-2 proximanova"
                                        autocomplete="off"
                                        maxlength="10"
                                        v-model="contactNumber"
                                        required
                                      />
                                      <span class="bar"></span>
                                      <label class="label-create required proximanova ml-3">Contact Number</label>
                                    </div>
                                  </div>
                                  <div v-if="errors.has('addBasicinfo.Mobile Number')" class="alert-danger d-block d-md-none ml-2">{{ errors.first('addBasicinfo.Mobile Number') }}</div>
                                </div>
                              </div>
                            </div>
                            <div class="row no-gutters mb-3 d-none d-md-block">
                              <div class="col d-md-flex col-12 justify-content-start align-items-center">
                                <div class="col-md-6">
                                  <div class="col d-flex ml-2">
                                    <span class="proximanova black60 fontsize12">Eg: Hyderabad,Telangana,India (City,state,country)</span>
                                    <div v-if="errors.has('addBasicinfo.Location')" class="alert-danger">{{ errors.first('addBasicinfo.Location') }}</div>
                                    <div v-if="LocationString.length>0 && !locationlistloader && !city && !state && !country" class="alert-danger">Please add valid Location</div>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 pl-0 pr-0">
                                  <div v-if="errors.has('addBasicinfo.Mobile Number')" class="alert-danger ml-2">{{ errors.first('addBasicinfo.Mobile Number') }}</div>
                                </div>
                              </div>
                            </div>
                            <div class="row no-gutters">
                              <div class="col-12">
                                <div class="col">
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      name="websiteURL"
                                      data-vv-as="websiteURL"
                                      data-vv-scope="addBasicinfo"
                                      class="input-create"
                                      v-model.trim="websiteURL"
                                      @keyup="checkWebsiteURL()"
                                      autocomplete="nope"
                                      required
                                    />
                                    <span class="bar"></span>
                                    <label class="label-create proximanova">Worknotion URL (Optional)</label>
                                  </div>
                                  <div class="col d-flex flex-column ml-2">
                                    <span class="proximanova black60 fontsize12">Eg: https://www.worknotion.com/wn/john123</span>
                                    <div v-if="websiteURL && websiteURL.length>0 && !validWebsiteURL" class="alert-danger">Please enter valid website URL</div>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters col-12 mb-3">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body ">
                        <div class="float-right">
                          <button class="mr-3 btn black mouseoverbtn1 border editprofile borderradius20" v-if="isEditPage" @click="cancelEditPage">
                            <span class="">Cancel</span>
                          </button>
                          <button class="mr-3 btn mouseoverbtn1 border createprofile borderradius20" v-if="!isEditPage" @click="clearSelectedData">
                            <span class="">Cancel</span>
                          </button>
                          <img src="../assets/uploadvideo.svg" width="32px" alt="uploading" class="img-fluid ml-2 mr-3" v-if="submitbtnDisabled">
                          <button class="mr-3 btn  btn sign-up-button blackbackhroundsignin borderradius20 fontsizemd proximanova mouseoverbtn2 white borderradius20" v-else id="finalsubmitbtn" @click="checkValidation">
                            <span class="button-cancel-font proximanova" v-if="companyProfileId != 'null' && companyProfileId != 'undefined'">Save</span>
                            <span class="button-cancel-font proximanova" v-else>Create</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters">
            <br />
          </div>
        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import htttpuserprofile from "@/js/http-userprofile.js";
import httpjob from "@/js/http-postjob.js"
import $ from "jquery";
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker';
import APIerrorModal from '../components/APIerrorpopup.vue'
import moment from 'moment'
import { bus } from "@/main.js";
import router from '../router';
import sessionUtils from "@/js/session-util.js";
import wndata from '../js/wn_data.json'
export default {
  components: {
    Multiselect,
    DatePicker,
    APIerrorModal
  },
  data() {
    return {
      sidemenuHeaderText : 'Create Company Account',
      isEditPage : false,
      pageloader : false,
      //profile image
      profilePicLink : null,
      DuplicateCompanyError : null,
      businessAccountId : null,
      companyProfileId : null,
      firstName : '',
      lastName : '',
      workEmail : '',
      companyName : '',
      selectedCompanyProfileId : null,
      LocationString : '',
      country : null,
      state : null,
      city : null,
      websiteURL : '',
      WorknotionUserProfileId : null,
      countyCodesList : [
        {countryName : 'India', countryCode : '+91' },
        {countryName : 'USA', countryCode : '+1' }
      ],
      contactNumber : '',
      countryCode : '+91',
      submitbtnDisabled : false,
      displayAPIerrorModal : false,
      //lists
      registeredCompaniesList : [],
      locationsList : [],
      companieslistloader : false,
      locationlistloader : false,
      //validations
      validfirstname : true,
      validlastname : true,
      validWebsiteURL : true,
    };
  },
  methods: {
    checkWebsiteURL() {
      // check for worknotion user URL
      let domainName = 'worknotion.com'
      this.WorknotionUserProfileId = null;
      if(this.websiteURL.length > 0){
        this.validWebsiteURL = this.websiteURL.includes(domainName)
        let url = this.websiteURL.replace("www.", "");
        console.log(url)
        if(this.validWebsiteURL){
          this.getUserProfileId(url)
        }
      }else{
        this.validWebsiteURL = true;
      }
    },
    getUserProfileId(url) {
      httpjob.get('/postjob/getUserAccordingToProfileLink?url='+url)
      .then((response) => {
        console.log("user profile id : ", response.data)
        if(response.data && (response.data.errorCode=='1021' || response.data.errorCode=='1051')){
          this.validWebsiteURL = false;
        }else{
          this.validWebsiteURL = true;
          this.WorknotionUserProfileId = response.data;
        }
      }).catch((e)=> {
        console.log(e.response)
        this.validWebsiteURL = false;
      })
    },
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
    getCompanyData(){
      httpjob.get('/postjob/getCompanyEmployeeDetails?businessAccountId='+this.businessAccountId)
      .then((response) => {
        console.log("recruiter profile data : ", response);
        this.pageloader = false;
        if(response.data.errorCode!='1021'){
        this.firstName = response.data.firstName;
        this.lastName = response.data.lastName;
        sessionUtils.setCompanyProfileId(response.data.employeeId)
        //location
        if(response.data.city){
          this.city = response.data.city.cityId;
        }
        if(response.data.state){
          this.state = response.data.state.stateId;
        }
        if(response.data.country){
          this.country = response.data.country.countryId
        }
        this.LocationString = response.data.location;
        //contact
        // this.contactNumber = response.data.phonenumber;
        let primaryMobileNumber = response.data.phonenumber;
            if(primaryMobileNumber) {
              let ind1 =  primaryMobileNumber.indexOf("(")
              console.log("index : ", ind1)
              if(ind1 !== null && ind1 !== undefined && ind1 >= 0){
                this.contactNumber = primaryMobileNumber.slice(ind1)
                this.countryCode = String(primaryMobileNumber.slice(0, ind1-1))
                console.log(this.contactNumber)
                console.log(this.countryCode)
              }else{
                this.contactNumber = primaryMobileNumber
                console.log(this.contactNumber)
              }
            }else{
              this.contactNumber = null
            } 
        //company
        this.companyName = response.data.companyprofiledata.companyName;
        this.selectedCompanyProfileId = response.data.companyprofiledata.companProfileId;
        //profilelink
        this.profilePicLink = response.data.userProfilePicture;
        if(response.data.userProfileId ) {
          this.WorknotionUserProfileId = response.data.userProfileId;
        }else{
          this.WorknotionUserProfileId = null;
        }
        this.websiteURL = response.data.profileLink;
        }
      }).catch((e) => {
        console.log(e)
        this.pageloader = false;
      })
    },
    //////////// form validations ///////////////
    allowOnlyNumbersandCharacters : function(event){
      var inputValue = event.charCode;
      var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
      if (charCode <= 64 && (charCode!= 32 && charCode != 0) || (charCode > 90 && charCode < 97)) {
          event.preventDefault();
      }
    },
    checkfornumbersanddigits : function() {
      var regalphnumspace = /^[a-z\s]+$/i;
      if(this.firstName){
        this.validfirstname = regalphnumspace.test(this.firstName);
      }
      if(this.lastName){
      this.validlastname = regalphnumspace.test(this.lastName)
      }
      console.log("validations : ", this.validfirstname, this.validlastname)
    },
    ///// this event will trigger on each key press in company name input to check wether company name is dupliacte or not/////
    checkCompany() {
      this.locationlistloader = false;
      this.locationsList = [];
      this.selectedCompanyProfileId = null;
      if(this.companyName.length >2){
        this.companieslistloader = true;
        this.registeredCompaniesList = [];
        httpjob.get('postjob/getCompanyDetailsBySearchText?text='+this.companyName)
        .then((response) => {
          console.log("fetch registered companieslist : ", response.data)
          this.companieslistloader = false;
          this.registeredCompaniesList = response.data;
        }).catch((e)=> {
          console.log(e.response)
          this.companieslistloader = false;
        })
      }else{
        this.companieslistloader = false;
        this.registeredCompaniesList = [];
      }
    },
    addCompany(companyName, companyprofileId) {
      this.companyName = companyName;
      this.selectedCompanyProfileId = companyprofileId;
      this.registeredCompaniesList = [];
      this.locationsList = [];
    },
    NavToCompanySignup() {
      var x = document.createElement('a')
      x.target = '_blank'
      x.href = wndata.companySignUp;
      x.click()
    },
    //////////////// location /////////////////
    checkLocation() {
      this.city = null;
      this.state = null;
      this.country = null;
      //reset data
      this.companieslistloader = false;
      this.registeredCompaniesList = []
      //check and get data
      if(this.LocationString.length >2){
        this.locationlistloader = true;
        this.locationsList = []
        httpjob.get('postjob/getLocationFromSearchText?text='+this.LocationString)
        .then((response) => {
          console.log("fetch locations list : ", response.data)
          this.locationlistloader = false;
          this.locationsList = response.data;
        }).catch((e)=> {
          console.log(e.response)
          this.locationlistloader = false;
        })
      }else{
        this.locationlistloader = false;
        this.locationsList = [];
      }
    },
    addLocation(loc, i) {
      this.LocationString = loc.location;
      this.city = loc.cityId;
      this.state = loc.stateId;
      this.country = loc.countryId;
      this.locationsList = [];
      this.registeredCompaniesList = [];
    },
    ///////////////////////////////About us section///////////////////////////////
    ///// this will invoke when add a number in contact number input filed/////
    formatCellPhoneNumber: function(event) {
      var phone = this.contactNumber;
      phone = phone
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/g, "($1) $2-$3");
      this.contactNumber = phone;
    },
    //// this will invoke for every required input filed to check details and enable and disable submit button////
    checkValidation(){
      var that = this
      this.$validator.validateAll("addBasicinfo").then((isValid) => {
        if(isValid && this.validfirstname && this.validlastname && this.validWebsiteURL && this.selectedCompanyProfileId && (this.city || this.state || this.country)){
          that.submitbtnDisabled = true;
          that.createBusinessAccount()
        } else{
          console.log("not valid")
          that.$toast.error("Please fill required information")
        }
      })
    },
    //this will invoke after click on create profile back button
    blockNavigation(){
      var vm = this;
      if(this.companyProfileId != 'null' && this.companyProfileId != 'undefined'){
        router.push({
          name : 'postedJobs'
        })
      }else{
        vm.$toast.info("User must create Recruiter account to access other screens")
      }
    },
    //this will invoke after click on cancel button when in create profile functionality
    clearSelectedData(){
      //company info
      this.companyName = '';
      this.websiteURL = '';
      //aboutus
      this.contactNumber = '';
      this.countryCode = '+91';
      //location
      this.country = null;
      this.state = null;
      this.city = null;
      this.submitbtnDisabled = false;
      document.getElementById("finalsubmitbtn").classList.remove("enableButton");
    },
    //this will invoke after click on cancel button when user in edit profile functionality
    cancelEditPage(){
      console.log("user in edit profile page")
      router.go(-1)
    },
    updateCompanyprofileId(){
      httpjob.get('postjob/getCompanyEmployeeDetails?businessAccountId='+this.businessAccountId)
      .then((response) => {
        console.log("recruiter profile data", response)
        sessionUtils.setCompanyProfileId(response.data.employeeId)
        this.companyProfileId = response.data.employeeId;
        this.profilePicLink = response.data.userProfilePicture;
        // setTimeout(() => {
        //   this.cancelEditPage()
        // }, 1000)
        if(!this.isEditPage){
          router.push({
            name : 'postajob'
          })
        }
      }).catch((e) => {
        console.log(e.response)
      })
    },
    // form submission
    createBusinessAccount() {
      var vm = this;
      let CompanyDetailsObj = {
        businessAccountId : this.businessAccountId,
        firstName : this.firstName,
        lastName : this.lastName,
        emailId : this.workEmail,
        companyId : this.selectedCompanyProfileId,
        city : this.city,
        state : this.state,
        country : this.country,
        userProfileId : this.WorknotionUserProfileId,
        phoneNo : this.countryCode +' '+this.contactNumber
      }
      console.log("final obj : ", CompanyDetailsObj)
      httpjob.post('/postjob/saveOrUpdateEmployee', CompanyDetailsObj)
      .then((response) => {
        console.log(response)
        this.submitbtnDisabled = false;
        if(this.isEditPage){
          vm.$toast.success("Successfully updated Recruiter account")
          this.updateCompanyprofileId()
        }else{
          vm.$toast.success("Successfully created Recruiter account")
          //update profile id into session storage for other screens
          this.updateCompanyprofileId() 
          sessionUtils.setRecruiterAccountStatus('PENDING')
        }
        bus.$emit('updateCompanyProfileInformation', true);
      }).catch((e) => {
        console.log(e)
        this.submitbtnDisabled = false;
        this.displayAPIerrorModal = true;
      })
    }
  },
  mounted: function() {
    //set page scroll
    window.scrollTo(0, 0)
    this.businessAccountId = sessionUtils.getBusinessAccountId()
    this.companyProfileId = sessionUtils.getCompanyProfileId()
    this.workEmail = sessionUtils.getCompanyEmail()
    let currentRoute = this.$route.name;
    this.getCompanyData()
    if(currentRoute === 'createprofile'){
      this.sidemenuHeaderText = 'Create Company Account'
      this.isEditPage = false
    }
    if(currentRoute === 'editprofile'){
      this.sidemenuHeaderText = 'Edit Company Account'
      this.isEditPage = true;
      this.pageloader = true;
      // this.getCompanyData()
    }
  },
  computed:{
  },
  destroyed() {
    // window.removeEventListener('scroll', this.handleScroll);
  }

};
</script>
<style scoped>
@import '../css/vue-multiselect.min.css';
@import '../css/vue2-datepicker.css';
@import '../css/croppie.css';
/* .experience .exp:nth-child(odd){background-color: #f3f3f3;} */
/* new css */
.profilepicturesection{
  background-color: rgba(161, 166, 179,.06);
}
.card-header a:focus{
  outline: none;
}
.card-body{
  border-radius: 0 10px 10px 0;
}
/* end new css */
ul li::marker {
  color: #1f1f1f;
  text-decoration: underline;
  opacity: 0.8;
  font-size: 0px;
  list-style: none !important;
}

.fixing{
position:fixed;
   left:100px;
}
.dropdown-menu{
  z-index: 3;
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  margin-top: 0px;   
  border-radius: 10px  !important;
}
.dropdownheight {
  height: 300px;
  overflow: auto;
}
.list-group-item{
  padding: .25rem 0.25rem;
  border: none;
  line-height: 20px;
}
.list-group-item:hover{
  background: rgba(31,31,31,.2) !important;
}
.header {
  position: fixed;
  width: 100%;
  z-index: 3;
  background: #ffffff;
  border-bottom: 2px solid rgba(219, 219, 219,1);
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border: none;
  /* border-bottom: 1px solid #757575; */
}
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
.countryCodeInput{
  padding-right: 0;
  padding-left: 0;
  margin-top: 8px;
}
.countryCodeInputfield{
  font-size: 15px;
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}
.multiselectInput-create:hover {
  border-bottom: 1px solid #0078FF !important;
}

/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}

#main {
  margin: 0px 0px;
}
.duplicateError{
  color: red;
  text-align: center;
}
#main #faq .card {
  margin-bottom: 30px;
  border: 0;
  border-radius: 10px
}
a{
  white-space: nowrap !important;
}
#main #faq .card .card-header {
  border: 0;
  -webkit-box-shadow: 0 0 20px 0 rgba(213, 213, 213, 0.5);
  box-shadow: 0 0 20px 0 rgba(213, 213, 213, 0.5);
  border-radius: 2px;
  padding: 0;
}

#main #faq .card .card-header .btn-header-link {
  display: block;
  text-align: left;
   background:
rgba(255,255,255,1);

  color: #222;
  padding: 20px;
}

#main #faq .card .card-header .btn-header-link:after {
  /* content: "\f107"; */
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  float: right;
}

#main #faq .card .card-header .btn-header-link.collapsed {
  background:
rgba(255,255,255,1);

}

#main #faq .card .card-header .btn-header-link.collapsed:after {
  /* content: "\f106"; */
}

#main #faq .card .collapsing {
  background: #ffffff;
  line-height: 30px;
}

#main #faq .card .collapse {
  border: 0;
  border-radius: 10px;
}

#main #faq .card .collapse.show {
  background: #ffffff;
  line-height: 30px;
  color: #222;
}

.button-create {
  border-radius: 4px;
  background-color: #fdfafa;
  border: 1px solid #fdfafa;
}

.button-create-font {
  /* color: rgb(141, 135, 135); */
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: bold;
}
.button-cancel {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 4px;
}

.button-cancel1 {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 4px;
  /* transition: border 8s; */
}
/* .button-cancel1:hover{
  opacity: 1;
  background: -webkit-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
  border: 2px solid transparent;
  border-radius: 10px !important;
  -moz-border-image: -moz-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  -webkit-border-image: -webkit-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  border-image: linear-gradient(to bottom, #E6784F 0%, #EA5184 100%);
  border-image-slice: 1;
} */
#exampleFormControlFile2 {
  display: none;
}
.border{
  padding-left: 10px;
}

.button-cancel-font {
  font-family: "Proxima Nova";
  font-size: 14px;
  font-weight: 600;
  /* color: #1f1f1f; */
  cursor: pointer;
}
.modaldeletebtn{
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
select{
  font-family: "Proxima Nova Regular";
}
.modaldeletebtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.modaldeletebtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.card-footer {
  background-color: rgba(255,255,255,1)!important;
}

.border-bottom{
  margin-left: 20px;
  margin-right: 20px
}

.img-bgcolor{
  background-color: #A1A6B3;
  opacity:60%
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.border-tab{
  border-left-style: solid;
  border-left-width:4px;
  border-left-color: #0078FF;
}
.addmore {
  cursor: pointer;
  padding: 1px;
  width: 215px;
}
.addmore:hover{
  border-radius: 16px;
  padding: 0px;
  background-color: rgba(161, 166, 179,0.1);
  border: 1px solid rgba(161, 166, 179,.5);
}
.list-Font-color{
  opacity: 0.8;
  color: #1F1F1F;
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
}
.profile-pic {
	position: relative;
	display: inline-block;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
/* .profile-pic:hover .edit {
	display: block;
} */

.edit {
  cursor: pointer;
  width: 25px;
  border: 1px solid #ced4da;
  border-radius: 50%;
	/* padding-top: 7px;
	padding-right: 7px; */
	position: absolute;
	right: 0;
	top: 0;
  margin-top:70%
	/* display: none; */
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.list-text-color{
  color: #0078FF !important;
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
}

.nav>li>a:focus, .nav>li>a:hover {
        text-decoration: none;
        background-color: transparent !important;
  }

 /* #main #faq .card .card-header .btn-header-link.collapsed:after {
    content: url("../assets/arrowdown.svg");
 } */

/* #main #faq .card .card-header .btn-header-link:after {
    content: url("../assets/arrow.svg");
    float: right;
} */



.searchResults {
  position:absolute; 
  background-color: white; 
  z-index: 50;
  top: 50px;
 
}

.fontsize-20{
  color: #1F1F1F;
  font-family: "Proxima Nova";
  font-size: 20px;
  font-weight: 600;
}

/* .preview {
  max-width:250px;
  max-height:250px;
} */

.modal-height{
  height: 450px;
  /* width: 656px !important; */
  width: 100% !important;
  border-radius: 10px !important;

}
.border-tab-bottom{
    border-bottom-style: solid;
    border-bottom-color: #0078FF;
  }
.modal-body{
  background-color: #000000
}
.modal-delete {
  background-color: white;
  border-radius: .3rem;
  padding-top: 0 !important;
}
.delete-modal{
  border: none;
}
.modal-footer{
  background-color: #ffffff
}
#deleteExpModal{
  margin-top: 15%;
}
#deleteEduModal{
  margin-top: 15%;
}
html,
body,
.grid {
   height: 100%;
  width: 100%;
   /* height: 300px;
  width: 315px;
    margin: -.89px; */
}
.grid {
    /* background-image:
      repeating-linear-gradient(#ccc 0 1px, transparent 1px 100%),
      repeating-linear-gradient(90deg, #ccc 0 1px, transparent 1px 100%); */
    background-size: 81px 81px;
     border-radius: 50%;
     overflow: hidden;
}

.circle{
  height: 300px;
  width: 315px;
  border-radius: 50%;
  border:1px solid white;
}

.photo{
  height: 96px;
  width: 96px;
  background-color: rgba(255,255,255,1);
  border-radius: 50%
}
.knowledgeItem {
  border-radius: 10px;
  font-family: "Proxima Nova";
  cursor: pointer;
}
.zoomControlText {
  color: white;
  font-size:13px
}
.circle-padding{
   /* padding: 100px 185px 136px 171px; */
   padding-left: 15%  !important;
   padding-top: 6%;
   padding-bottom: 6%;
   text-align:center
}

 .input-tag {
     background-color: black!important;
    /* border-radius: 2px; */
    /* border: 1px solid #a5d24a; */
    /* color: #638421; */
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    /* margin-bottom: 4px; */
    margin-right: 4px;
    padding: 3px;
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 4;
}
@media only screen and (max-width: 600px){
  .pageloader {
    width: 20%;
    margin-top: 25%;
  }
  .exppadding {
    padding-left: 0px !important;
    padding-right: 8px !important;
  }
  .edupadding {
    padding-left: 0px !important;
    padding-right: 8px !important;
  }
  .locInput {
    padding-left: 0px !important;
    padding-right: 8px !important;
  }
  .profimg {
    width: 210px !important;
  }
  .footer {
    position: fixed;
    bottom: 0;
  }
  .experiences{
    padding-left: 0 !important;
  }
  .mobviewItems {
    font-size: 10px  !important;
    overflow-x: auto;
  }
  a.list-Font-color{
    white-space: nowrap !important;
  }
  .list-Font-color{
    opacity: 0.8;
  color: #1F1F1F;
  font-family: "Proxima Nova";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  white-space: nowrap;
  }
  .circle-padding{
   /* padding: 100px 185px 136px 171px; */
    padding-left: 7%  !important;
    padding-top: 6%;
    text-align:center
  }
  .modal-height{
    margin-top: 20%;
    width: 100% !important;
  }
}
.createsidemenu{
  position: relative;
}
@media screen and (min-width: 800px) {
  .createsidemenu{
    position: fixed;
  }
  .centercard{
    margin-left: 25%;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
  .mobviewItems{
    overflow: auto;
  }
}
@media screen and (max-width: 768px) and (min-width: 600px){
  .list-Font-color{
    opacity: 0.8;
    color: #1F1F1F;
    font-family: "Proxima Nova";
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    white-space: nowrap;
  }
  .footer {
    position: fixed;
    bottom: 0;
  }
}

</style>
